import axios from "axios";

// Same base-URL convention used across the app (see streakApi/ViewStatus/UploadStatus).
export const BASE_URL =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

// Reactions supported by the status viewer (mirrors the backend enum).
export const STATUS_REACTIONS = ["❤️", "😂", "😘", "😀", "👍"];

// GET /api/status/all — every active (non-expired) status, newest first.
export async function fetchAllStatuses() {
  const res = await axios.get(`${BASE_URL}/api/status/all`);
  return Array.isArray(res.data) ? res.data : [];
}

// POST /api/status/react/:statusId — add / change / toggle a reaction.
export async function reactToStatus(statusId, userId, emoji) {
  const res = await axios.post(`${BASE_URL}/api/status/react/${statusId}`, {
    userId,
    emoji,
  });
  return res.data;
}

// Normalise a populated-or-raw ObjectId reference to a plain id string.
export function refId(ref) {
  if (!ref) return "";
  return typeof ref === "object" ? ref._id : ref;
}

// Group a flat status list by owner → [{ user, statuses }] (newest user first).
export function groupStatusesByUser(statuses) {
  const map = statuses.reduce((acc, status) => {
    const uid = status.user?._id;
    if (!uid) return acc;
    if (!acc[uid]) acc[uid] = { user: status.user, statuses: [] };
    acc[uid].statuses.push(status);
    return acc;
  }, {});
  return Object.values(map);
}

// Build a lookup keyed by lowercased user-name so blog/author pages (which
// only know the author *name*) can tell whether that author has active
// statuses and whether the current viewer has already seen them all.
export function buildStatusIndex(statuses, viewerId) {
  const index = {};
  for (const status of statuses) {
    const name = status.user?.name?.trim().toLowerCase();
    if (!name) continue;
    if (!index[name]) {
      index[name] = {
        userId: status.user._id,
        name: status.user.name,
        count: 0,
        hasUnviewed: false,
      };
    }
    index[name].count += 1;
    const seen = (status.views || []).some((v) => refId(v) === viewerId);
    if (!seen) index[name].hasUnviewed = true;
  }
  return index;
}
